import { render, staticRenderFns } from "./AppNavigationItem.vue?vue&type=template&id=7e1eda36"
import script from "./AppNavigationItem.vue?vue&type=script&lang=ts"
export * from "./AppNavigationItem.vue?vue&type=script&lang=ts"
import style0 from "./AppNavigationItem.vue?vue&type=style&index=0&id=7e1eda36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemIcon,VListItemTitle})
